import _extends from "@babel/runtime/helpers/extends";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _typeof from "@babel/runtime/helpers/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { forwardRef, useImperativeHandle, useState } from "react";
import { CheckoutReview } from "@components/organisms";
import { statuses as dummyStatuses } from "@components/organisms/DummyPaymentGateway";
import { useAuth, useCheckout } from "@saleor/sdk";
import { AlertCheckoutErrors } from "@temp/components";
import { GatewayTypesEnum } from "@globalTypes/globalTypes";

var CheckoutReviewSubpageWithRef = function CheckoutReviewSubpageWithRef(_ref, ref) {
  var _checkout$shippingMet;

  var selectedPaymentGateway = _ref.selectedPaymentGateway,
      selectedPaymentGatewayToken = _ref.selectedPaymentGatewayToken,
      setUpdateCheckoutState = _ref.setUpdateCheckoutState,
      paymentGatewayFormRef = _ref.paymentGatewayFormRef,
      changeSubmitProgress = _ref.changeSubmitProgress,
      onSubmitSuccess = _ref.onSubmitSuccess,
      props = _objectWithoutProperties(_ref, ["selectedPaymentGateway", "selectedPaymentGatewayToken", "setUpdateCheckoutState", "paymentGatewayFormRef", "changeSubmitProgress", "onSubmitSuccess"]);

  var _useCheckout = useCheckout(),
      checkout = _useCheckout.checkout,
      payment = _useCheckout.payment,
      completeCheckout = _useCheckout.completeCheckout;

  var _useAuth = useAuth(),
      user = _useAuth.user;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      errors = _useState2[0],
      setErrors = _useState2[1];

  var _useState3 = useState(""),
      _useState4 = _slicedToArray(_useState3, 2),
      checkoutObservation = _useState4[0],
      setCheckoutObservation = _useState4[1];

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      showErrors = _React$useState2[0],
      setShowErrors = _React$useState2[1];

  var checkoutShippingAddress = React.useMemo(function () {
    var _checkout$shippingAdd;

    return (checkout === null || checkout === void 0 ? void 0 : checkout.shippingAddress) ? _objectSpread(_objectSpread({}, checkout === null || checkout === void 0 ? void 0 : checkout.shippingAddress), {}, {
      phone: (checkout === null || checkout === void 0 ? void 0 : (_checkout$shippingAdd = checkout.shippingAddress) === null || _checkout$shippingAdd === void 0 ? void 0 : _checkout$shippingAdd.phone) || undefined
    }) : undefined;
  }, [checkout === null || checkout === void 0 ? void 0 : checkout.shippingAddress]);
  var checkoutBillingAddress = React.useMemo(function () {
    var _checkout$billingAddr;

    return (checkout === null || checkout === void 0 ? void 0 : checkout.billingAddress) ? _objectSpread(_objectSpread({}, checkout === null || checkout === void 0 ? void 0 : checkout.billingAddress), {}, {
      phone: (checkout === null || checkout === void 0 ? void 0 : (_checkout$billingAddr = checkout.billingAddress) === null || _checkout$billingAddr === void 0 ? void 0 : _checkout$billingAddr.phone) || undefined
    }) : undefined;
  }, [checkout === null || checkout === void 0 ? void 0 : checkout.billingAddress]);
  var showErrorsFunction = React.useCallback(function (errors) {
    setErrors(errors);
  }, []);
  var manualTransferChannelName = React.useMemo(function () {
    var gatewayId = selectedPaymentGateway || (payment === null || payment === void 0 ? void 0 : payment.gateway);

    if (gatewayId !== GatewayTypesEnum.MANUAL_TRANSFER) {
      return undefined;
    }

    var channelToken = (payment === null || payment === void 0 ? void 0 : payment.token) || selectedPaymentGatewayToken;

    if (channelToken && channelToken !== "manual_transfer") {
      return channelToken;
    }

    return undefined;
  }, [payment === null || payment === void 0 ? void 0 : payment.gateway, payment === null || payment === void 0 ? void 0 : payment.token, selectedPaymentGateway, selectedPaymentGatewayToken]);
  var paymentMethodName = React.useMemo(function () {
    var gatewayId = selectedPaymentGateway || (payment === null || payment === void 0 ? void 0 : payment.gateway);

    if (gatewayId === "mirumee.payments.dummy") {
      var _dummyStatuses$find;

      return "Dummy: ".concat((_dummyStatuses$find = dummyStatuses.find(function (status) {
        return status.token === selectedPaymentGatewayToken;
      })) === null || _dummyStatuses$find === void 0 ? void 0 : _dummyStatuses$find.label);
    }

    if (gatewayId === "mirumee.payments.adyen") {
      return "Adyen payments";
    }

    if (payment === null || payment === void 0 ? void 0 : payment.creditCard) {
      return "Ending in ".concat(payment === null || payment === void 0 ? void 0 : payment.creditCard.lastDigits);
    }

    if (gatewayId === GatewayTypesEnum.CASH) {
      return "cash";
    }

    if (gatewayId === GatewayTypesEnum.DATAPHONE) {
      return "dataphone";
    }

    if (gatewayId === GatewayTypesEnum.NEQUI) {
      return "nequi";
    }

    if (gatewayId === GatewayTypesEnum.ONLINE_CREDIBANCO) {
      return "online credibanco";
    }

    if (gatewayId === GatewayTypesEnum.MANUAL_TRANSFER) {
      return "manual_transfer";
    }

    return "";
  }, [payment === null || payment === void 0 ? void 0 : payment.creditCard, payment === null || payment === void 0 ? void 0 : payment.gateway, selectedPaymentGateway, selectedPaymentGatewayToken]);
  var handleComplete = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var data, dataError, _paymentGatewayFormRe, _dataError, response, _errors, _errors$graphQLErrors, temporalErrors, _data, _data$order, _data2, _data2$order, _data3, _data3$order, _data3$order$paymentG, _data5, _data5$order, _data6, _data6$order, _data7, _data7$order, _data4, _data4$order;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            changeSubmitProgress(true);

            if (!((payment === null || payment === void 0 ? void 0 : payment.gateway) === "mirumee.payments.adyen")) {
              _context.next = 5;
              break;
            }

            (_paymentGatewayFormRe = paymentGatewayFormRef.current) === null || _paymentGatewayFormRe === void 0 ? void 0 : _paymentGatewayFormRe.dispatchEvent(new Event("submitComplete", {
              cancelable: true
            }));
            _context.next = 24;
            break;

          case 5:
            _context.next = 7;
            return completeCheckout({
              checkoutObservation: checkoutObservation
            }, (user === null || user === void 0 ? void 0 : user.email) || "");

          case 7:
            response = _context.sent;
            data = response.data;
            dataError = response.dataError;
            _errors = (_dataError = dataError) === null || _dataError === void 0 ? void 0 : _dataError.error;

            if (!_errors) {
              _context.next = 17;
              break;
            }

            temporalErrors = _errors;

            if (_typeof(_errors) === "object" && (_errors === null || _errors === void 0 ? void 0 : (_errors$graphQLErrors = _errors.graphQLErrors) === null || _errors$graphQLErrors === void 0 ? void 0 : _errors$graphQLErrors.length) > 0) {
              temporalErrors = _errors.graphQLErrors.map(function (error) {
                var _error$extensions, _error$extensions$exc, _error$extensions$exc2;

                return {
                  code: (_error$extensions = error.extensions) === null || _error$extensions === void 0 ? void 0 : (_error$extensions$exc = _error$extensions.exception) === null || _error$extensions$exc === void 0 ? void 0 : (_error$extensions$exc2 = _error$extensions$exc.code) === null || _error$extensions$exc2 === void 0 ? void 0 : _error$extensions$exc2.toUpperCase()
                };
              });
              setErrors(temporalErrors);
              showErrorsFunction(temporalErrors);
            } else {
              setErrors(temporalErrors);
              showErrorsFunction(temporalErrors);
            }

            setShowErrors(true);
            _context.next = 23;
            break;

          case 17:
            setErrors([]);
            localStorage.setItem("order_token", (_data = data) === null || _data === void 0 ? void 0 : (_data$order = _data.order) === null || _data$order === void 0 ? void 0 : _data$order.token);

            if (!(((_data2 = data) === null || _data2 === void 0 ? void 0 : (_data2$order = _data2.order) === null || _data2$order === void 0 ? void 0 : _data2$order.paymentReturnUrl) && ((_data3 = data) === null || _data3 === void 0 ? void 0 : (_data3$order = _data3.order) === null || _data3$order === void 0 ? void 0 : (_data3$order$paymentG = _data3$order.paymentGateway) === null || _data3$order$paymentG === void 0 ? void 0 : _data3$order$paymentG.toLowerCase()) === GatewayTypesEnum.ONLINE_CREDIBANCO.toLowerCase())) {
              _context.next = 22;
              break;
            }

            window.location.href = (_data4 = data) === null || _data4 === void 0 ? void 0 : (_data4$order = _data4.order) === null || _data4$order === void 0 ? void 0 : _data4$order.paymentReturnUrl;
            return _context.abrupt("return");

          case 22:
            onSubmitSuccess({
              id: (_data5 = data) === null || _data5 === void 0 ? void 0 : (_data5$order = _data5.order) === null || _data5$order === void 0 ? void 0 : _data5$order.id,
              orderNumber: (_data6 = data) === null || _data6 === void 0 ? void 0 : (_data6$order = _data6.order) === null || _data6$order === void 0 ? void 0 : _data6$order.number,
              token: (_data7 = data) === null || _data7 === void 0 ? void 0 : (_data7$order = _data7.order) === null || _data7$order === void 0 ? void 0 : _data7$order.token
            });

          case 23:
            changeSubmitProgress(false);

          case 24:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [checkoutObservation, payment, user, showErrorsFunction]);
  useImperativeHandle(ref, function () {
    return {
      complete: handleComplete
    };
  });
  React.useEffect(function () {
    localStorage.removeItem("flag-input-other-values");
    localStorage.setItem("flag_address", "true");
    return function () {};
  }, []);
  return React.createElement(React.Fragment, null, React.createElement(CheckoutReview, _extends({}, props, {
    token: payment === null || payment === void 0 ? void 0 : payment.token,
    shippingAddress: checkoutShippingAddress,
    billingAddress: checkoutBillingAddress,
    checkoutObservation: checkoutObservation,
    setCheckoutObservation: setCheckoutObservation,
    shippingMethodName: checkout === null || checkout === void 0 ? void 0 : (_checkout$shippingMet = checkout.shippingMethod) === null || _checkout$shippingMet === void 0 ? void 0 : _checkout$shippingMet.name,
    paymentMethodName: paymentMethodName,
    manualTransferChannelName: manualTransferChannelName,
    email: checkout === null || checkout === void 0 ? void 0 : checkout.email,
    errors: errors
  })), showErrors && React.createElement(AlertCheckoutErrors, {
    hideModal: function hideModal() {
      setShowErrors(false);
      setErrors([]);
    },
    completeCheckoutAgain: function completeCheckoutAgain() {
      if (handleComplete) {
        handleComplete();
      }
    },
    updatePaymentMethod: function updatePaymentMethod() {
      setUpdateCheckoutState(true);
    },
    errors: errors
  }));
};

var CheckoutReviewSubpage = forwardRef(CheckoutReviewSubpageWithRef);
export { CheckoutReviewSubpage };